import { Layout } from 'antd';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { FooterComponent } from './Components/Footer/footer';
import { HeaderComponent } from './Components/Header/header';
import { Router } from './Components/Router/router';
import { FormDeclarationProvider } from './Context/DeclarationContext';
import { TrackingProvider } from './Context/TrackingContext';
import { LandingComponent } from './Pages/Landing/landing';
import { LandingFooterComponent } from './Pages/Landing/Footer';

function App() {
  return (
    <div
      style={{
        overflowX: 'hidden',
      }}
    >
      <BrowserRouter>
        <Routes>
          <Route path="*" element={<SystemComponent />} />
          <Route path="/" element={<LandingComponent />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

const SystemComponent = () => {
  // const [AccidentForm, setAccidentForm] = useState(initialState);
  // const [headerSection, setHeaderSection] = useState("");
  // const [step, setStep] = useState(0);
  // const [CurrentForm, setCurrentForm] = useState(0);

  // const valueProvider: providerValue = {
  //     AccidentForm,
  //     setAccidentForm,
  // 	headerSection,
  // 	setHeaderSection,
  // 	step,
  // 	setStep,
  // 	currentForm: CurrentForm,
  // 	setCurrentForm: setCurrentForm,
  // }

  return (
    <FormDeclarationProvider>
      <TrackingProvider>
        <Layout>
          <HeaderComponent />
          <Router />
          <LandingFooterComponent />
        </Layout>
      </TrackingProvider>
    </FormDeclarationProvider>
  );
};

export default App;
